<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame pb" id="_idContainer002">
<p class="p1 ParaOverride-1"><a id="intro"></a><span class="CharOverride-1">Introduction</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">Have you ever looked at your significant other and thought, “Wow, we have a weird relationship. If other people saw what we do, it would be odd and embarrassing”? Well, to be honest, that’s what we thought, too, before the comics began.</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">It all started on Thanksgiving Day 2016 when John and I were chatting about the mere-exposure effect in psychology—the idea that encountering someone more increases their chances of liking you. John suggested that it would be a great premise for a comic: Me, following John around, trying to encounter him more.</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">Three hours and a Thanksgiving dinner later, the first Catana Comic had been created, and within a week, five more. The comics were intended for John’s eyes only, but John was convinced that the Internet would love them. So with my timid approval, he posted them. We were instantly floored by the amount of support the comics received.</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">Who would’ve known how many odd, happy couples were just like us? We surely didn’t know back then. But a little more than a year later, we are surrounded by them! We constantly feel overjoyed by our followers’ love, positivity, and silliness. We love to read and hear everyone’s kind comments and their own little jokes, see people tagging their significant others, and feel their blatantly overflowing love for their relationship.</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">Even though these comics were not in our life plan at all, they have become so important to us! We are just a happy little couple from Upstate New York (and when I say little, I mean John is six foot seven, so maybe little isn’t quite accurate).</span></p>
<p class="p1 ParaOverride-2"><span class="CharOverride-2">Our followers and fans are very important to us. Without you guys, we would not be writing this. Thank you to everyone who finds joy in Catana Comics—it warms our hearts to know that there are so many other couples out there fueled by love, silliness, ponytail beards, finger guns, and good ol’ snugging. We hope you find yourselves in the pages of this book.</span></p>
</div>
<div class="_idGenObjectLayout-1r t">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/Catana_sig.jpg" style="width: 30%;"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LittleMoments_epub.vue?d3ef244e